import { StarIcon } from '@heroicons/react/24/outline';
import QuantityConfig from '../components/quantity-config';
import { Col, Container, Row, Image, Button } from 'react-bootstrap'
import { Product } from '../types';
import { stripHtmlTags, thousandSeparator } from '../helper/utils';
import { useCartActions } from '../hooks/use-cart-actions';
import { useCallback, useState } from 'react';
import { usePricingModel } from '../hooks/use-pricing-model';

interface SingleProductProps {
    product: Product;
    currentQty: number;
}

const SingleProduct = ({ product, currentQty }: SingleProductProps) => {

    const { handleAddToCart, handleQuantityChange } = useCartActions();
    const [newQty, setNewQty] = useState<number>(0);
    const { renderProductPricingModelJSX } = usePricingModel();

    const handleAddProductToCart = () => {
        handleAddToCart({...product, productImages: [], inventories: []});
        handleQuantityChange(product.id, newQty);
    }

    const handleQuantity = useCallback((quantity: number) => setNewQty(quantity), []);
    
    return (
        <section id="single-product" className='mb-5'>
            <Container>
                <Row>
                    {/* Product Image */}
                    <Col md={12} lg={6} sm={12} xs={12} className='mb-4'>
                        <Image src={product.image} fluid rounded />
                    </Col>

                    {/* Product Info */}
                    <Col md={12} lg={6} sm={12} xs={12}>
                        <h3 className='mt-0' style={{fontSize: '1.8rem', fontWeight: '500', marginBottom: '14px'}}>{product.name}</h3>
                        <div className="flex flex-col" style={{  }}>
                            <div className="flex items-center mb-2" style={{ fontSize: '.8rem'}}>
                                <small className="text-warning inline-flex items-center">
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                    <StarIcon width={15} style={{ fill: '#ffc107' }} />
                                </small>
                                <a href="#" className="text-success" style={{ marginLeft: '6px' }}>(30 reviews)</a>
                            </div>
                            <div className="text-md">
                                {renderProductPricingModelJSX(product)}
                            </div>
                        </div>
                        <hr />
                        <Row className="my-4">
                            <Col xs={6} md={4} lg={3}>
                                <QuantityConfig size='sm' currentQty={currentQty} handleQuantitySetter={handleQuantity} />
                            </Col>
                            <Col xs={6} md={3} style={{marginLeft: 0}}>
                                <Button variant="primary" style={{ borderRadius: '8px', fontSize: '.8rem'}} onClick={handleAddProductToCart}>
                                    Add to Cart
                                </Button>
                            </Col>
                        </Row>
                        <hr />
                        <Row className="my-4" style={{ fontSize: '.9rem', color: '#666' }}>
                            <Col xs={12} lg={12}>
                                <Row className='mb-3'>
                                    <Col xs={3}>Availability:</Col>
                                    <Col xs={3}><span className='text-success'>{thousandSeparator(product.qtyInStock.toFixed(0))}</span> <small>In Stock</small></Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col xs={3}>Category:</Col>
                                    <Col xs={3}>{product.category.name}</Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col xs={3}>Shipping:</Col>
                                    <Col xs={9}>We ship to your door step within 24 - 48hrs</Col>
                                </Row>
                            </Col>
                        </Row>
                        <hr />
                        <Row className="my-4" style={{ fontSize: '.9rem', color: '#666' }}>
                            <Col xs={12} lg={12}>
                                { stripHtmlTags(product?.description) }
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default SingleProduct